/**
 * Configuration file to load settings based on the TARGET_SERVER environment variable.
 */

// Define configurations for different servers
const serverConfigs = {

    // Configuration for yarn build cfra
    'cfra': {
        code: "cfra",
        host: 'https://km-bizz.com:8080/mycanal/',
        licence: 'https://km-bizz.com:8080',
        SERVER_ID: 1
    },
    // Configuration for yarn build cafr
    'cafr': {
        code: "cafr",
        host: '/mycanal/',
        licence: 'https://canal-afri.km-bizz.com',
        SERVER_ID: 2
    },
    'cpfra': {
        code: "cpfra",
        host: '/mycanal/',
        licence: 'https://canal-afra.km-bizz.com',
        SERVER_ID: 3
    },
    'fr': {
        code: "fr",
        host: '/mycanal/',
        licence: 'https://canal-fr.km-bizz.com',
        SERVER_ID: 4
    },
    // Default configuration (e.g., for local development or if no target is specified)
    'default': {
        code: "default",
        host: 'http://localhost:8070/',
        licence: 'https://localhost:8070/',
        SERVER_ID: 0
    },
    'debug': {
        code: "debug",
        host: 'https://canal-fr.km-bizz.com/mycanal/',
        licence: 'https://canal-fr.km-bizz.com',
        SERVER_ID: 5
    }
};

// Read the environment variable set by the build script
const targetServer = process.env.TARGET_SERVER || 'cpfra';

// Get the specific configuration object
const config = serverConfigs[targetServer] || serverConfigs['cpfra'];

// Export the configuration for use in the React components
export default config;